module.exports = __webpack_public_path__ + "static/18gde-d4acd790b771953e4134e9aae0c36b9e.gif";